module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/success-icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("İşleminiz Başarılı!")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'GetStarted',
      }
    }
  }, [_c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n    BAŞA DÖN\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52066a14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Success.vue
// module id = 234
// module chunks = 1